import { getCmsBaseUrl } from '@/lib/cms';

/** Absolute URL for a Strapi upload path or full URL. */
export function absCmsMediaUrl(mediaUrl?: string | null): string {
  const raw = String(mediaUrl ?? '').trim();
  if (!raw) return '';
  if (raw.startsWith('http://') || raw.startsWith('https://')) return raw;
  const base = getCmsBaseUrl().replace(/\/+$/, '');
  return raw.startsWith('/') ? `${base}${raw}` : `${base}/${raw}`;
}
